export const bannerData = {
  className: 'landing-banner',
  title: `          
    <span class="text-blue">Integration platforms don't work.</span>
    <br />
    Scale your in-house integration development with an AI-powered framework.
  `,
}
